import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'saveDialog',
  props: {
    saveDialog: null
  },
  emits: ['update:stopDialog', 'submit', 'cancel'],
  setup(__props: any, { emit }) {

const props = __props as {
  saveDialog: {
    visible: boolean;
    taskName: string;
    saveLoading: boolean;
    cancelSaveLoading: boolean;
  }
}

const rules = {
  taskName: [
    {
      validator: (rule: any, value: string, cb: Function) => {
        if(!value) {
          cb(new Error('任务名不能为空'))
        } else {
          cb()
        }
      },
      trigger: ['blur']
    }
  ]
}


const __saveDialog = computed({
  get() {
    return props.saveDialog
  },
  set(newVal) {
    emit('update:stopDialog', newVal)
  }
})
function handleSubmit() {
  const taskName = __saveDialog.value.taskName
  console.log('提交任务-taskName: ', taskName)
  emit('submit')
}
function cancelSubmit() {
  __saveDialog.value.visible = false
  emit('cancel')
}

return { __sfc: true,rules, props, emit, __saveDialog, handleSubmit, cancelSubmit }
}

})